import BlogDetail from "../../../commonComponents/blogDetail";

const BlogQuoteLayoutContainer = () => {
  return <BlogDetail type="quote_box" />;
};

export default BlogQuoteLayoutContainer;
